class HHVariantPicker extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.scrollHHMediaSlider()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
    }
  }

  scrollHHMediaSlider() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return

    let mainSlider = document.querySelector('hh-image-carousel.product-media__sticky')
    if (!!!mainSlider) return;

    let variantImage = this.currentVariant?.featured_media?.preview_image.src
    let allSlides = mainSlider.querySelectorAll('.slide.product-media')

    if (!!!variantImage || !!!allSlides) return;

    let variantSlideIndex = [...allSlides].findIndex(slide => slide.dataset.url === variantImage)

    mainSlider.moveTo(variantSlideIndex)
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.sp-product-variant-size, .vp__input--button, .js-dropdown-input'))
    if (fieldsets && fieldsets.length) {
      this.options = fieldsets.map((fieldset) => {
        if (fieldset.classList.contains('sp-product-variant-size')) {
          return Array.from(fieldset.querySelectorAll('input')).find(
            (radio) => radio.checked
          ).value
        } else if (fieldset.classList.contains('vp__input--button')) {
          return Array.from(fieldset.querySelectorAll('input')).find(
            (radio) => radio.checked
          ).value
        } else if (fieldset.classList.contains('js-dropdown-input')) {
          return fieldset.querySelector('input')?.value
        }
      })
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] == option
        })
        .includes(false)
    })
    window.variantPrice = this.currentVariant.price / 100
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    )
    if (!newMedia) return
    const parent = newMedia.parentElement
    parent.prepend(newMedia)
    window.setTimeout(() => {
      parent.scroll(0, 0)
    })
  }

  updateURL() {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
      const inputUrl = productForm.querySelector('input[name="sections_url"]')
      inputUrl.value = `${this.dataset.url}?variant=${this.currentVariant.id}`
      inputUrl.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        // Get components to update
        const id = `price-${this.dataset.section}`
        const destination = document.getElementById(id)
        const source = html.getElementById(id)

        const cartNotificationId = `cart-notification-product--${this.dataset.section}`
        const cartNotificationDestination = document.querySelector(`[data-section-id="${cartNotificationId}"]`)
        const cartNotificationSource = html.querySelector(`[data-section-id="${cartNotificationId}"]`)

        const errorNotificationId = `cart-notification-product-error-${this.dataset.section}`
        const errorNotificatioDestination = document.querySelector(`[data-section-id="${errorNotificationId}"]`)
        const errorNotificatioSource = html.querySelector(`[data-section-id="${errorNotificationId}"]`)

        const errorMessageId = `js-product-form__error-message--${this.dataset.section}`
        const errorMessageDestination = document.getElementById(errorMessageId)
        const errorMessageSource = html.getElementById(errorMessageId)

        const quantityButtonId = `quantity-input-${this.dataset.section}`
        const quantityButtonDestination = document.getElementById(quantityButtonId)
        const quantityButtonSource = html.getElementById(quantityButtonId)

        const atcFormId = `atc-form-${this.dataset.section}`
        const atcFormDestination = document.getElementById(atcFormId)
        const atcFormSource = html.getElementById(atcFormId)

        // Update components if they exist
        if (source && destination) destination.innerHTML = source.innerHTML

        if (cartNotificationSource && cartNotificationDestination) cartNotificationDestination.innerHTML = cartNotificationSource.innerHTML

        if (errorNotificatioSource && errorNotificatioDestination) errorNotificatioDestination.innerHTML = errorNotificatioSource.innerHTML

        if (errorMessageSource && errorMessageDestination) errorMessageDestination.innerHTML = errorMessageSource.innerHTML

        if (quantityButtonSource && quantityButtonDestination) quantityButtonDestination.innerHTML = quantityButtonSource.innerHTML

        if (atcFormSource && atcFormDestination) atcFormDestination.dataset.itemid = atcFormSource.dataset.itemid //Needed to cart notification price update

        if (atcFormSource && atcFormDestination) atcFormDestination.querySelector('[name=quantity]').dataset.product = atcFormSource.querySelector('[name=quantity]').dataset.product

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden')
        this.toggleAddButton(
          !this.currentVariant.available,
          window.langMessages['products.product.sold_out']
        )

        // Change overall price if we have the subscription price
        const subscriptionWidget = document.querySelector('recharge-subscription-widget')
        const overallPrice = document.querySelector('.product__price .price dd')
        const originalPrice = document.querySelector('.product__price .price div.price__strikethrough dd')
        let customStrikethroughPrice = document.createElement('div')
        customStrikethroughPrice.classList.add('price__strikethrough')

        let subscriptionPrice;

        subscriptionWidget?.shadowRoot?.querySelector('.rc-purchase-option[rc-selected] .rc-price:not(.strike-through)')?.childNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE && node.nodeValue.includes('$')) {
            subscriptionPrice = node.nodeValue
          }
        });

        if (!!!overallPrice || !!!subscriptionWidget || !!!subscriptionPrice) return;

        overallPrice.textContent = subscriptionPrice.replace('.00', '')

        if (`$${window.variantPrice}` != subscriptionPrice.replace('.00', '')) {
          if (originalPrice) {
            originalPrice.textContent = `$${window.variantPrice}`
          } else {
            let priceElement = document.createElement('dd')
            priceElement.textContent = `$${window.variantPrice}`
            customStrikethroughPrice.appendChild(priceElement)

            overallPrice.closest('.price')?.prepend(customStrikethroughPrice)
          }
        } else {
          if (originalPrice) originalPrice.remove()
        }

      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')

    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', true)
      if (text) addButton.textContent = text
    } else {

      addButton.removeAttribute('disabled')

      const subscriptionWidget = document.querySelector('recharge-subscription-widget')

      // Change price in ATC if we have the subscription price
      let subscriptionPrice;

      subscriptionWidget?.shadowRoot?.querySelector('.rc-purchase-option[rc-selected] .rc-price:not(.strike-through)')?.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue.includes('$')) {
          subscriptionPrice = node.nodeValue
        }
      });

      addButton.textContent = (!!subscriptionWidget && !!subscriptionPrice)
        ? `${window.langMessages['products.product.add_to_cart']} - ${subscriptionPrice.replace('.00', '')}`
        : `${window.langMessages['products.product.add_to_cart']} - $${this.currentVariant.price / 100}`

      window.variantPrice = this.currentVariant.price / 100
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    if (!addButton) return
    addButton.textContent = window.langMessages['products.product.unavailable']
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('hh-variant-picker', HHVariantPicker)
